import { createContext, useContext, useMemo, useState } from 'react';

function isoDaysAgo(days) {
  const d = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  return d.toISOString().slice(0, 10);
}

const AdminFiltersContext = createContext(null);

export function AdminFiltersProvider({ children }) {
  const [from, setFrom] = useState(isoDaysAgo(30));
  const [to, setTo] = useState(isoDaysAgo(0));
  const [market, setMarket] = useState('all');

  const value = useMemo(
    () => ({
      from,
      to,
      market,
      setFrom,
      setTo,
      setMarket,
      asQuery: () => {
        const params = new URLSearchParams();
        if (from) params.set('from', new Date(from).toISOString());
        if (to) params.set('to', new Date(to + 'T23:59:59').toISOString());
        if (market && market !== 'all') params.set('market', market);
        return params.toString();
      },
    }),
    [from, to, market]
  );

  return <AdminFiltersContext.Provider value={value}>{children}</AdminFiltersContext.Provider>;
}

export function useAdminFilters() {
  const ctx = useContext(AdminFiltersContext);
  if (!ctx) throw new Error('useAdminFilters must be used within AdminFiltersProvider');
  return ctx;
}
